import { containsDateRange, DateRange } from 'owa-datetime-utils';
import { EventEntity } from '../schema/EventEntity';
import { EventsCache, EventsCacheLockId } from '../schema/EventsCache';
import { getEventsFromCache } from './getEventsFromCache';

export function getEventsInDateRangeFromLock<T extends EventEntity>(
    dateRange: DateRange,
    lockId: EventsCacheLockId,
    cache: EventsCache<T>
): T[] | null {
    const lockedDateRange =
        cache && cache.locksInfo.get(lockId) ? cache.locksInfo.get(lockId).lockedDateRange : null;

    if (lockedDateRange == null || !containsDateRange(lockedDateRange, dateRange, true)) {
        return null;
    } else {
        return getEventsFromCache(dateRange, cache.events);
    }
}
